// Message
import MessageCenter from '@/views/admin/MessageCenter.vue'
import AllSubscribers from '@/views/admin/messageCenter/AllSubscribers.vue'
import CustomersTestimonials from '@/views/admin/messageCenter/CustomerTestimonials.vue'
import CustomersMessage from '@/views/admin/messageCenter/CustomerMessage.vue'
import BroadcastMessage from '@/views/admin/messageCenter/Broadcast.vue'
import ViewMessage from '@/views/admin/messageCenter/viewMessage.vue'

const messageRoutes = {
  path: '/hrd12/hrd12/messages',
  component: MessageCenter,
  redirect: '/hrd12/hrd12/messages/message',
  name: 'MessageCenter',
  meta: {
    title: 'Message Center'
  },
  children: [
    {
      path: '/hrd12/hrd12/messages/all-subscribers',
      component: AllSubscribers,
      name: 'All Subscribers',
      meta: {
        title: 'All Subscribers'
      }
    },
    {
      path: '/hrd12/hrd12/messages/view/:id',
      component: ViewMessage,
      name: 'ViewMessage',
      meta: {
        title: 'View Message'
      }
    },
    {
      path: '/hrd12/hrd12/messages/customers-testimonials',
      component: CustomersTestimonials,
      name: 'CustomersSubscribers',
      meta: {
        title: 'Customers Subscribers'
      }
    },
    {
      path: '/hrd12/hrd12/messages/customers-request',
      component: CustomersMessage,
      name: 'CustomersMessage',
      meta: {
        title: 'Customers Message'
      }
    },
    {
      path: '/hrd12/hrd12/messages/broadcast-message',
      component: BroadcastMessage,
      name: 'BroadcastMessage',
      meta: {
        title: 'Broadcast Message'
      }
    }
  ]
}

export default messageRoutes
